<template>
  <!-- 上传记录 - 上传中 author: zhangxiaofeng-->
  <div class="upload-history width-fullh height-full">
    <div class="upload-table-wrapper" :class="{pagination: totalCount > pageSize}" id="upload-table-wrapper">
      <!--<simple-table :height="tableHeight">-->
        <!--<template slot="header">-->
          <!--<thead class="has-gutter">-->
          <!--<tr class>-->
            <!--<th class="font-left" width="20">-->
              <!--<i class="file-icons-null"></i>-->
            <!--</th>-->
            <!--<th class="font-left" width="150">名称</th>-->
            <!--<th class="font-center" width="80">文件类型</th>-->
            <!--<th class="font-center" width="80">上传时间</th>-->
            <!--<th class="font-center" width="80">文件大小</th>-->
            <!--<th class="font-center" width="80">上传状态</th>-->
            <!--<th class="font-center" width="150">上传说明</th>-->
          <!--</tr>-->
          <!--</thead>-->
        <!--</template>-->
        <!--<template slot="body" v-if="dataList.length>0">-->
          <!--<thead class="ui-table_head">-->
            <!--<tr height="42">-->
            <!--<th class="font-left" width="20"></th>-->
            <!--<th class="font-left" width="150">名称</th>-->
            <!--<th class="font-center" width="80">文件类型</th>-->
            <!--<th class="font-center" width="80">上传时间</th>-->
            <!--<th class="font-center" width="80">文件大小</th>-->
            <!--<th class="font-center" width="80">上传状态</th>-->
            <!--<th class="font-center" width="150">上传说明</th>-->
          <!--</tr>-->
          <!--</thead>-->
          <!--<tbody id="projectContent">-->
          <!--<tr v-for="(i, index) in dataList" :key="index">-->
            <!--<td class="font-left" width="20">-->
              <!--<i-->
                <!--:class="['file-icons', 'icon_' + i.suffix, 'icon_' + i.fileType, i.folder ? 'folder': '']"-->
              <!--&gt;</i>-->
            <!--</td>-->
            <!--<td class="font-left name-td" width="150">-->
              <!--<div class="name-div" :title="i.fileName">-->
                <!--{{i.fileName}}-->
                <!--<span class="upload-new" v-if="i.unread==1"></span>-->
              <!--</div>-->
            <!--</td>-->
            <!--<td class="font-center" width="80">{{i.projectType}}</td>-->
            <!--<td class="font-center" width="80">{{i.beginTime | formatDate}}</td>-->
            <!--<td class="font-center" width="80">{{i.fileSize}}</td>-->
            <!--<td class="font-center" width="80">{{i.statusName}}</td>-->
            <!--<td class="font-center" width="150">-->
              <!--<span-->
                <!--v-if="uploadTypeList.indexOf(0)>-1 && (+i.result.result === 0 || i.result.result === 'false')"-->
                <!--class="errmsg-project"-->
              <!--&gt;-->
                <!--{{i.result.errMsg?i.result.errMsg:'服务器异常'}}-->
                <!--<i class="font-red w-icon-tishi1" style="font-size: 12px;"></i>-->
              <!--</span>-->
              <!--<a-->
                <!--v-if="uploadTypeList.indexOf(0)==-1 && i.result && i.result.UnImportEstiCount + i.result.UnImportedBQCount > 0"-->
                <!--@click="getDetail(i.uuid, i)"-->
                <!--class="error-msg cursor-pointer"-->
              <!--&gt;{{i.result.UnImportEstiCount + i.result.UnImportedBQCount}}条数据未导入，查看详情</a>-->
              <!--<span-->
                <!--v-else-if="uploadTypeList.indexOf(0)==-1 &&i.result && i.result.AllEstiCount + i.result.AllBQCount == 0"-->
                <!--:title="title"-->
                <!--class="errmsg-project"-->
              <!--&gt;该工程没有清单或组价</span>-->
              <!--<span-->
                <!--v-else-if="uploadTypeList.indexOf(0)==-1 &&!i.result && i.status==3"-->
                <!--:title="title"-->
                <!--class="errmsg-project"-->
              <!--&gt;-->
                <!--文件格式不支持-->
                <!--<i class="font-red w-icon-tishi1" style="font-size: 12px;"></i>-->
              <!--</span>-->
            <!--</td>-->
          <!--</tr>-->
          <!--</tbody>-->
        <!--</template>-->
        <!--<div slot="body" v-else class="empty-box">-->
          <!--<img src="@/assets/images/default_empty.png" />-->
          <!--<p>还没有{{uploadTypeList.indexOf(0)>-1?"工程":uploadTypeList.indexOf(2)>-1?"清单":"组价"}}上传记录</p>-->
        <!--</div>-->
      <!--</simple-table>-->
      <div class="ui-fixed tree-table fit flex flex-column table-medium table-beyond-hiding" style="height: calc(100% - 8px);" id="tree-table" v-loading="loading">
        <div class="header-wrapper" ref="headerWrapper">
          <div class="table-header flex flex-row" style="width: 100%;">
            <div class="header-item is-leaf" style="width: 80px;"></div>
            <div class="header-item is-leaf flex-1">名称</div>
            <div class="header-item is-leaf" style="width: 100px;">文件类型</div>
            <div class="header-item is-leaf" style="width: 100px;">上传时间</div>
            <div class="header-item is-leaf" style="width: 100px;">文件大小</div>
            <div class="header-item is-leaf" style="width: 100px;">上传状态</div>
            <div class="header-item is-leaf" style="width: 200px;">上传说明</div>
            <div class="has-gutter" v-if="scrollY"></div>
          </div>
        </div>
        <div class="body-wrapper flex-1" :class="{'relative': dataList.length === 0}" style="overflow: auto;" ref="bodyWrapper">
          <ul class="container" :style="{width: tableWidth + 'px'}" ref="containerWrapper" v-if="dataList.length>0">
            <li v-for="(i, index) in dataList" :key="index" class="flex flex-row row row--level-1">
              <div class="cell column_1" style="width: 80px;">
                <i :class="['file-icons', 'icon_' + i.suffix, 'icon_' + i.fileType, i.folder ? 'folder': '']"></i>
              </div>
              <div class="cell column_2  flex-1">
                <div class="name-div" :title="i.fileName">
                  {{i.fileName}}
                  <span class="upload-new" v-if="i.unread==1"></span>
                </div>
              </div>
              <div class="cell column_3" style="width: 100px;">{{i.projectType}}</div>
              <div class="cell column_3" style="width: 100px;">{{i.beginTime | formatDate}}</div>
              <div class="cell column_3" style="width: 100px;">{{i.fileSize}}</div>
              <div class="cell column_3" style="width: 100px;">{{i.statusName}}</div>
              <div class="cell column_5" style="width: 200px;">
                <span
                  v-if="uploadTypeList.indexOf(0)>-1 && (+i.result.result === 0 || i.result.result === 'false')"
                  class="errmsg-project"
                >
                {{i.result.errMsg?i.result.errMsg:'服务器异常'}}
                <i class="font-red w-icon-tishi1" style="font-size: 12px;"></i>
              </span>
                <a
                  v-if="uploadTypeList.indexOf(0)==-1 && i.result && i.result.UnImportEstiCount + i.result.UnImportedBQCount > 0"
                  @click="getDetail(i.uuid, i)"
                  class="error-msg cursor-pointer"
                  style="position: relative;top:0 !important"
                >{{i.result.UnImportEstiCount + i.result.UnImportedBQCount}}条数据未导入，查看详情</a>
                <span
                  v-else-if="uploadTypeList.indexOf(0)==-1 &&i.result && i.result.AllEstiCount + i.result.AllBQCount == 0"
                  :title="title"
                  class="errmsg-project"
                >该工程没有清单或组价</span>
                <span
                  v-else-if="uploadTypeList.indexOf(0)==-1 &&!i.result && i.status==3"
                  :title="title"
                  class="errmsg-project"
                >
                文件格式不支持
                <i class="font-red w-icon-tishi1" style="font-size: 12px;"></i>
              </span>
              </div>
            </li>
          </ul>
          <div class="absolute text-align-center" style="top: 50%;left: 50%;transform: translate(-50%,-50%);" v-else>
            <div class="text-align-center color-white" style="width:56px;height:56px;line-height:56px;background:rgba(33,37,48,0.15);border-radius: 50%;margin: 0 auto;">
              <i class="r2-icon-action_description" style="font-size: 30px;"></i>
            </div>
            <div class="text-align-center font-16 color-999" style="font-size:14px;margin-top: 12px">
              还没有{{uploadTypeList.indexOf(0)>-1?"工程":uploadTypeList.indexOf(2)>-1?"清单":"组价"}}上传记录
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page-box" v-show="totalCount>pageSize">
      <w-pagination
        @current-change="handleCurrentChange"
        @size-change="handlePageSizeChange"
        :page-sizes="[20, 50, 100, 200]"
        background
        layout="total, prev, pager, next, jumper, sizes"
        :page-size="pageSize"
        :total="totalCount"
      ></w-pagination>
    </div>
  </div>
</template>
<script>
// import { SimpleTable } from '@/components/common'
import UploadHistoryService from '@/assets/service/uploadhistory'
import { formatDate } from '@/assets/utils/Date'
import { mapState, mapMutations } from 'vuex'
export default {
  data: () => {
    return {
      scrollY: false,
      loading: false,
      // tableHeight: 300,
      dataList: [],
      totalCount: 0,
      pageSize: 20,
      pageNum: 1,
      statusList: [2],
      uploadTypeList: [],
      title: '工程文件支持导入范围:08,13清单，后缀名\n为GBQ5,GPB5,GPV5,GSC5,GSH5,GBQ6,\nGPB6,GPV6,GSC6,GSH6的工程'
    }
  },
  computed: {
    ...mapState({
      uploadhistory: state => state.sidebarData.uploadhistory,
      uploadMessage: state => state.upload.message
    })
  },
  props: {
    module: {
      default: ''
    }
  },
  components: {
    // SimpleTable
  },
  filters: {
    formatDate (value) {
      return formatDate(new Date(value), 'yyyy-MM-dd')
    }
  },
  methods: {
    ...mapMutations({
      setUploadData: 'sidebarData/SET_UPLOAD_DATA',
      setUploadMessage: 'upload/SET_UPLOAD_MESSAGE'
    }),
    // setTableHeight() {
    //   // let winH = document.documentElement.clientHeight
    //   // this.tableHeight = winH - 200
    // },
    // 更改页显示多少
    handlePageSizeChange (index) {
      this.pageSize = index
      this.queryUploadList(this.statusList, this.uploadTypeList)
      let menu = JSON.parse(JSON.stringify(this.uploadhistory))
      this.$root.$children[0].$children[1].sideBarData = menu
    },
    // 更改页码
    handleCurrentChange (index) {
      this.pageNum = index
      this.queryUploadList(this.statusList, this.uploadTypeList)
      let menu = JSON.parse(JSON.stringify(this.uploadhistory))
      this.$root.$children[0].$children[1].sideBarData = menu
    },
    // 获取请求列表
    queryUploadList () {
      let _self = this
      let tableTypeOne = _self.uploadTypeList[0]
      let params = {
        pageNum: _self.pageNum,
        pageSize: _self.pageSize,
        statusList: _self.statusList,
        uploadTypeList: _self.uploadTypeList
      }
      _self.dataList = []
      _self.loading = true
      let apiName = 'queryUploadListBigData'
      if (JSON.stringify(this.uploadTypeList) === '[0,1]') { apiName = 'queryUploadList' }
      UploadHistoryService[apiName](params).then(res => {
        _self.loading = false
        if (_self.uploadTypeList[0] !== tableTypeOne) {
          return
        }
        if (+res.code === 200) {
          _self.dataList = res.data.items
          _self.totalCount = res.data.totalCount
        } else {
          _self.dataList = []
        }
      }).catch(() => {
        _self.loading = false
      })
    },
    // 打开详情
    getDetail (uuid) {
      const { href } = this.$router.resolve({
        path: '/upload/detail',
        query: {
          uuid: uuid
        }
      })
      window.open(href, '_blank')
    },
    // 删除小红点
    delete (val) {
      let _self = this
      val = '' + val
      if (_self.uploadMessage.indexOf(val) === -1) {
        return
      }
      let apiName = 'deleteUploadPointBigData'
      if (+val === 1) {
        apiName = 'deleteUploadPoint'
      }
      UploadHistoryService[apiName](val).then(res => {
        if (+res.code === 200) {
          let menu = JSON.parse(JSON.stringify(_self.uploadhistory))
          if (+val === 1) {
            menu[2].children[0].point = false
          } else if (+val === 2) {
            menu[2].children[1].children[0].point = false
          } else {
            menu[2].children[1].children[1].point = false
          }
          let mssages = _self.uploadMessage.split(',').filter(i => {
            return i !== val
          })
          _self.setUploadMessage(mssages.length ? mssages.join(',') : '0')
          _self.setUploadData(menu)
        }
      })
    }
  },
  watch: {
    $route (to, from) {
      let _self = this
      _self.pageNum = 1
      if (to.path.indexOf('project') > -1) {
        _self.uploadTypeList = [0, 1]
        _self.delete(1)
      } else if (to.path.indexOf('list') > -1) {
        _self.uploadTypeList = [2, 3, 4]
        _self.delete(2)
      } else {
        _self.uploadTypeList = [5, 6, 7]
        _self.delete(3)
      }
      _self.queryUploadList(_self.statusList, _self.uploadTypeList)
    }
  },
  mounted () {
    if (this.$route.path.indexOf('project') > -1) {
      this.uploadTypeList = [0, 1]
      this.delete(1)
    } else if (this.$route.path.indexOf('list') > -1) {
      this.uploadTypeList = [2, 3, 4]
      this.delete(2)
    } else {
      this.uploadTypeList = [5, 6, 7]
      this.delete(3)
    }
    this.queryUploadList(this.statusList, this.uploadTypeList)
    // setTimeout(this.setTableHeight, 200)
    // this.resizeHandle.resize(() => {
    //   this.setTableHeight()
    // })
  },
  updated () {
    let scrollY
    try {
      scrollY = this.$refs.containerWrapper.clientHeight > this.$refs.bodyWrapper.clientHeight
    } catch (e) {
      scrollY = false
    }
    this.scrollY = scrollY
  }
}
</script>
